// extracted by mini-css-extract-plugin
export default {"pageHeader":"style_pageHeader__38nf0","content":"style_content__zToTq","dangerIcon":"style_dangerIcon__+28Kx"};